import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AdvancePreferencesHttpModel } from '../../http/profile/profile-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const AdvancePreferencesActions = createActionGroup({
  source: 'Advance Preferences',
  events: {
    'Load Advance Preferences': emptyProps(),
    'Refresh Advance Preferences': emptyProps(),
  },
});

export const AdvancePreferencesAPIActions = createActionGroup({
  source: 'Advance Preferences API',
  events: {
    'Loaded Advance Preferences Successfully': props<{
      advancePreferences: AdvancePreferencesHttpModel;
    }>(),
    'Loaded Advance Preferences Unsuccessfully': props<{
      error: ErrorResponse;
    }>(),
  },
});
